export default __webpack_public_path__ + "static/media/i-no-collateral.391d7bc2.svg";